<template>
  <v-hover v-show="showCheck()" #default="{ hover }" class="ma-2">
    <v-card class="grey lighten-5 single-thumb" width="220px" :data-photo-id="photoObj.id">
      <v-img transition="fade-transition" height="293px" width="220px" :src="photoObj.url_thumbnail" @click="dialog = true">
        <v-icon
          v-if="currentUser.permissions.publish_photos === true && photoObj.published_to_client == true"
          large
          color="secondary"
          style="position: absolute; top:5px; left:5px;"
        >mdi-send-circle-outline</v-icon>

        <v-expand-transition>
          <div
            v-if="hover"
            class="d-flex transition-fast-in-fast-out grey darken-2 v-card--reveal white--text align-center justify-center pa-4"
            style="height: 100%;"
          >
            <p class="photo-meta caption d-block clearfix">{{ chain }}: {{ photoObj.name | truncate(310) }}</p>
          </div>
        </v-expand-transition>
        <template #placeholder>
          <v-row class="fill-height ma-0" align="center" justify="center">
            <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
          </v-row>
        </template>
      </v-img>

      <div class="image-details pa-2 d-flex justify-space-between align-center">
        <span class="image-title pa-0 caption d-flex flex-column">
          <a
            @click="dialog = true"
            class="pa-0 ma-0 store-name font-weight-bold"
          >{{ storeName }}</a>
          <span class="pa-0 ma-0 photo-date">{{formatedDate}}</span>
          <small class="pa-0 ma-0 photo-geocode" v-if="photoObj.geocode">
            Geocode: <a :href="geocodeLink" target="_blank">{{ photoObj.geocode }}</a>
          </small>
        </span>
        <div class="image-actions">
          <v-dialog max-width="1200" v-model="dialog" class="image-popup">

            <v-btn color="primary" @click="dialog = false" icon class="popup-close">
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
            <SingleImageLarge :photo="photo" :index="index" />
          </v-dialog>

          <v-btn
            @click="toggleCollectionAddItem()"
            :color="added ? 'secondary' : 'primary'"
            fab
            width="30px"
            height="30px"
            elevation="1"
          >
            <v-icon v-if="added == true">mdi-check</v-icon>
            <v-icon v-else>mdi-plus</v-icon>
          </v-btn>
        </div>
      </div>
    </v-card>
  </v-hover>
</template>

<script>
import { mapGetters } from "vuex";
import store from "@/store/";
import { SELECT_PHOTO_ADD, SELECT_PHOTO_REMOVE } from "@/store/actions.type";

export default {
  name: "SingleImage",
  props: {
    photo: {
      type: Object,
      required: false
    },
    index: null
  },
  data: () => ({
    dialog: false,
    added: false,
    add: false,
    photoHolder: {
      id: 9999,
      name: "Photo Name",
      url: "https://picsum.photos/510/300?random"
    }
  }),
  filters: {
    truncate(value, length) {
      if (!value) return "";
      value = value.toString();
      if (value.length > length) {
        return value.substring(0, length) + "...";
      } else {
        return value;
      }
    }
  },
  computed: {
    chain() {
      if (this.photo) {
        return this.photo.calls.stores.chains.name;
      }
      return '';
    },
    storeName() {
      if (this.photo) {
        return this.photo.calls.stores.name;
      }
      return '';
    },
    photoObj() {
      if (this.photo) {
        if (!this.photo.selected) this.photo.selected = false;
        return this.photo;
      }
      return this.photoHolder;
    },
    selected() {
      return this.imageSearchResult.data[this.index].selected;
      //return this.photo.selected
    },
    formatedDate() {
      if (this.photo) {
        var dateobj = new Date(this.photo.meta_photo_date_time);
        function pad(n) {
          return n < 10 ? "0" + n : n;
        }
        return (
          pad(dateobj.getDate()) +
          "/" +
          pad(dateobj.getMonth() + 1) +
          "/" +
          dateobj.getFullYear() +
          " " +
          dateobj.getHours() +
          ":" +
          pad(dateobj.getMinutes())
        );
      }
    },
    geocodeLink() {
      let latlon = [];
      let latlonComma = "";
      if (this.photo.geocode) {
        if (this.photo.geocode.indexOf("-") !== -1) {
          latlon = this.photo.geocode.split("-");
          latlonComma = `${latlon[0]},-${latlon[1]}`;
        } else {
          latlon = this.photo.geocode.split(".");
          const firstOfLon = latlon[1].slice(-1);
          const endOfLat = latlon[1].slice(0, -1);
          latlonComma = `${latlon[0]}.${endOfLat},${firstOfLon}.${latlon[2]}`;
        }
        console.log(
          "%cSingleImageLarge.vue line:80 object",
          "color: #007acc;",
          latlon
        );
        return `https://google.com/maps/search/?api=1&query=${latlonComma}`;
      }
      return null;
    },
    ...mapGetters([
      "selectedImages",
      "imageSearchResult",
      "showSelected",
      "selectedImagesIds",
      "currentUser"
    ])
  },
  watch: {
    selectedImagesIds(val) {
      this.added = val.includes(this.photoObj.id);
    }
  },
  methods: {
    // If we want linking
    // addIdUrl(id) {
    //   console.log(id)
    // },
    showCheck() {
      if (this.showSelected === true) {
        if (this.photo.selected === true) {
          return true;
        }
        return false;
      }
      return true;
    },
    toggleCollectionAddItem() {
      if (this.selectedImagesIds.includes(this.photoObj.id)) {
        this.added = false;
      } else {
        this.added = true;
      }

      let i = this.index;
      const action = this.added ? SELECT_PHOTO_ADD : SELECT_PHOTO_REMOVE;
      this.$store.dispatch(action, { index: this.index, photo: this.photoObj });
    }
  },
  mounted() {
    this.added = this.selectedImagesIds.includes(this.photoObj.id);
  }
};
</script>
